module.exports = __webpack_public_path__ + "img/photo212.388183cd.jpg";